import React from 'react';
import s from '../styles/Loader.module.css';

const Loader = () => {
  return (
    <div className={s.loader_container}>
      <div className={s.spinner}></div>
      <div className={s.text}>Загрузка...</div>
    </div>
  );
};

export default Loader;
